import Select, { type Params as SelectParams } from 'Components/smallComponents/select';
import type { TemplateFunction, TemplateResult } from 'Components/types';
import { discardField, replaceValue, toggle } from 'Core/actions/request';
import { useDispatch } from 'Core/store';
import { DisplayMode } from 'Modules/serverApi/types';
import { cloneSafe } from 'Utils/components';
import { simpleHandler } from 'Utils/roleHandler';

import type { FacetCommonProps } from '../baseFacet';

export default function SelectFacet({
  facet,
  templateFunc,
  config,
  facetRef,
  commonParams,
  commonRoles,
}: FacetCommonProps): TemplateResult {
  const dispatch = useDispatch();

  const { displayMode } = facet;
  const isMultiSelect = displayMode === DisplayMode.MultiSelect;

  const select = (templ: TemplateFunction<SelectParams>) => {
    const props = {
      template: templ,
      entries: facet.facetedValues.map((v) => ({
        value: v.value,
        term: v.term,
        selected: !!v.isSelected,
        hitCount: v.hitCount,
        url: v.url,
      })),
      extraClassName: 'cm_facet_select',
      field: facet.field,
      title: facet.name,
      hideNullOption: true,
      showCheckboxes: isMultiSelect,
      disabled: !facet.facetedValues.length,
      useNativeDropdown: config.useNativeDropdown ?? !isMultiSelect,
      showHitCount: config.showHitCount ?? true,
      onChange: (term: string) =>
        dispatch(
          !term
            ? discardField(facet.field, { mayDiscardValue: true })
            : isMultiSelect
              ? toggle({ field: facet.field, term }, { isSingleValue: !isMultiSelect, mayDiscardValue: true })
              : replaceValue({ field: facet.field, term }, { mayDiscardValue: true }),
        ),
    };
    return <Select {...props} key={`select-${facet.field}`} />;
  };

  const onClick = simpleHandler({ ...commonRoles });

  const component = templateFunc.call({ ...commonParams, select });

  return cloneSafe(component, facetRef, { onClick });
}
